import { render, staticRenderFns } from "./ThemeWeek.vue?vue&type=template&id=9efc0b54&scoped=true"
import script from "./ThemeWeek.vue?vue&type=script&lang=ts"
export * from "./ThemeWeek.vue?vue&type=script&lang=ts"
import style0 from "./ThemeWeek.scss?vue&type=style&index=0&id=9efc0b54&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efc0b54",
  null
  
)

export default component.exports